import { Component, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
//import { SwUpdate } from '@angular/service-worker';
import { CustomSnackbarComponent } from '@shared/components/custom-snackbar/custom.component';
import { PushNotificationService } from '@shared/services/firebase/push-notification.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private forceReload = false;
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private notification: PushNotificationService,
    //private swUpdate: SwUpdate,
    private router: Router,
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
  ){
    this.iconRegistry.addSvgIcon('whatsapp', this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/whatsapp.svg'));
    /*
    if(this.swUpdate.isEnabled){
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        setTimeout(() => {
          /*Por si alguien reporta problemas de caché (suele pasar de que se vuelve a versiones viejas del service-worker).
          * Se cambia a true el valor inicial de forceReload
          *
          if(this.forceReload){
            window.location.reload();
            this.forceReload = false;
          }
          this.swUpdate.checkForUpdate().then(() => {
            this.swUpdate.versionUpdates.subscribe(event => {
              if (event.type === 'VERSION_READY') {
                this.swUpdate.activateUpdate().then(() => {
                  localStorage.setItem('app-updated', 'true');
                  window.location.reload();
                });
              }
            });
          }).catch(err => {
            console.error('Error al verificar actualizaciones:', err);
          });
        }, 2000);
      });
    }
    */
  }
  
  ngOnInit():void{
    this.notification.requestPermission();
    this.notification.receiveMessage();
  }
  
  ngAfterViewInit(){
    /* 
    if (localStorage.getItem('app-updated')) {
      if(window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone){
        this.showCustomSnackbar('La APP ha sido actualizada');
      }
      setTimeout(() => {
        this.viewContainerRef.clear();
      }, 5000);
      localStorage.removeItem('app-updated');
    }
    */
  }
  
  showCustomSnackbar(message: string): void {
    this.viewContainerRef.clear();
    const factory = this.resolver.resolveComponentFactory(CustomSnackbarComponent);
    const componentRef = this.viewContainerRef.createComponent(factory);
    componentRef.instance.message = message;
  }
}

import { BUILD_VERSION } from '../version'; // Asegurate de que la ruta sea correcta

@Component({
  selector: 'app-version',
  template: `<p class="version truncate">Versión de build: {{ buildVersion }}</p>`,
  styleUrls: ['./app.component.scss']
})
export class VersionComponent {
  buildVersion = BUILD_VERSION;
}
